import { Box, Text } from '@jfs/ui-new'
import { useCallback, useEffect } from 'react'
import {
  getLeftHeaderInTabNavigator,
  getRightHeaderInTabNavigator
} from '../../comps/CustomHeader/headerFunctionHelpers'
import { SvgImage } from '../../comps/SvgImage'
import { getString } from '../../util/languageStrings'
import { Colors, getScreenTitle, logEvent } from '../../util/util'
import { config, styles } from './index'

const spaceAdjustor = (value: number) => {
  return <Box mt={value} />
}

const mapIndex = {
  home: 0,
  qr: 2,
  transactions: 1,
  // settlements: 3,
  profile: 4,
} as any

export const TabBar = ({
  state,
  selectedAppLanguage,
  descriptors,
  navigation,
  totalTabsPresent,
  availableTabs,
}: any) => {
  const index = state?.index ?? 0
  const indexMapper: any = mapIndex[availableTabs[index]]

  let timer = state?.routes[indexMapper]?.params?.time
  const filterData = state?.routes[indexMapper]?.params?.filterData
  const showTimer = state?.routes[indexMapper]?.params?.showTimer
  const title = getScreenTitle()[indexMapper] ?? ''
  const isProfile = indexMapper === 4 || title === 'Profile'
  useEffect(() => {
    // console.log('isProfile', isProfile, indexMapper)
    navigation?.setOptions({
      title: title,
      headerStyle: { borderBottomWidth: 0.5 },
      headerShown: false, //isProfile ? false : true,
      headerLeft: () => getLeftHeaderInTabNavigator(indexMapper),
      headerRight: () => getRightHeaderInTabNavigator({ indexMapper, timer, filterData, showTimer }),
    })
  }, [filterData, indexMapper, isProfile, navigation, showTimer, timer, title, index])

  const isRoundedCornerTab = useCallback(
    (route: any) => {
      return availableTabs?.length % 2 === 1 && route.name === 'qr'
    },
    [availableTabs],
  )

  const getIcon = (focused: any, route: any) => {
    const getColor = () => {
      if (focused) {
        return 'PRIMARY'
      } else {
        return Colors.PRIMARY_GREY
      }
    }
    return (
      <Box {...styles.iconContainer(isRoundedCornerTab(route), focused, totalTabsPresent)}>
        {spaceAdjustor(2)}
        <SvgImage
          imageName={config[route.name]?.iconId}
          color={focused ? Colors.PRIMARY : Colors.PRIMARY_GREY}
          width={24}
          height={24}
        />
        {/* <Icon id={config[route.name]?.iconId} color={getColor()} size={22} /> */}
        {isRoundedCornerTab(route) ? (
          <>
            {spaceAdjustor(4)}
            <Text color={getColor()} fontFamily={'JioType-Medium'} fontSize={12}>
              {getString(selectedAppLanguage, `${config[route.name]?.label}`)}
            </Text>
          </>
        ) : null}
      </Box>
    )
  }

  return (
    <Box {...styles.tabContainer}>
      {state.routes.map((route: any, i: any) => {
        const { options } = descriptors[route.key]
        const isFocused = state.index === i
        const onPress = () => {
          logEvent('bottom_tab_press', route.name)
          if (route.name === 'profile') {
            navigation.navigate('profile', { screen: 'NewProfile' })
          } else {
            navigation.navigate(route.name)
          }
        }

        return (
          <Box
            key={i + route}
            testID={options.tabBarTestID}
            flex={1}
            alignItems="center"
            onPress={onPress}
            backgroundColor={'WHITE'}
            underlayColor="TRANSPARENT">
            {getIcon(isFocused, route)}
            {spaceAdjustor(-6)}
            <Text
              numberOfLines={1}
              fontFamily={'JioType-Medium'}
              fontSize={12}
              lineHeight={16}
              color={isFocused ? 'PRIMARY' : Colors.PRIMARY_GREY}>
              {isRoundedCornerTab(route) ? null : getString(selectedAppLanguage, `${config[route.name]?.label}`)}
            </Text>
            {spaceAdjustor(10)}
          </Box>
        )
      })}
    </Box>
  )
}
